import FormattedMessage from 'I18n/components/FormattedMessage';
import SectionHeading from '../../../components/SectionHeading';
import { View } from 'foundations-components/transitional/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverviewModalCurriculumSection = ({
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-accent-neutral-subtle-alt",
    color: "text-core-default",
    children: /*#__PURE__*/_jsxs(View, {
      padding: "800",
      paddingInline: isMobile ? '300' : undefined,
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(SectionHeading, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.overviewModal.curriculum"
          })
        })
      }), children]
    })
  });
};
export default OverviewModalCurriculumSection;